import "./TeamCard.css";
function extractor(url_id) {
    if (url_id) {
      if (url_id.search("google.com") !== -1) {
        var id = url_id.split("=");
        var url_link = "https://drive.google.com/uc?export=view&id=";
        var url = url_link.concat(id[1]);
      } else {
        url = url_id;
      }
  
      return url;
    } else
      return "https://drive.google.com/thumbnail?id=1mz35ArVCMbBHQTXebpm2OWFoTvTMrkXA";
  }
function TeamCard(props)
{  
    return(
              <div className="team-card">
                <div className="team-image-container">
                  <div className="team-image">
                    <img src={extractor(props.image)} alt="profile"></img>
                  </div>
                </div>
                <div className="team-details">
                  <div className="name">{props.name}</div> 
                  <div className="post">{props.position}</div>
                  {props.domain==="Wall of Fame" && <div className="year">{props.year}</div>}
                </div>
                <div className="links">
                    <a href={props.github} target="_blank" rel="noreferrer"><i className="fab fa-github fa-2x"></i></a>
                    <a href={props.linkedIn} target="_blank" rel="noreferrer"><i className="fab fa-linkedin fa-2x"></i></a>
                    <a href={props.twitter} target="_blank" rel="noreferrer"><i className="fab fa-twitter fa-2x"></i></a>
                </div>
              </div>
    );
}
export default TeamCard;